// @flow
import React from 'react'
import {UncontrolledTooltip, FormGroup, Row, Label, Col} from 'reactstrap';
import TranslateComponent from './TranslateComponent';
import classNames from 'classnames';
import newId from "./newId";

const DEFAULT_INPUT_CLASS = {xs: 12, sm:8, md: 8, lg: 8, xl: 8};
const DEFAULT_OFFSETS_INPUT_CLASS = {xsOffset: 0, smOffset:4, mdOffset: 4, lgOffset: 4, xlOffset: 4};

class FieldGrid extends React.Component {
    static PropTypes = {
        label: React.PropTypes.oneOf([React.PropTypes.string, React.PropTypes.array, React.PropTypes.element, React.PropTypes.bool]).isRequired,
        checkboxLabel: React.PropTypes.oneOf([React.PropTypes.string, React.PropTypes.array, React.PropTypes.element, React.PropTypes.bool]).isRequired,
        children: React.PropTypes.element.isRequired,
        labelPosition: React.PropTypes.string,
        required: React.PropTypes.bool,
        check: React.PropTypes.bool,  // pokud je true, jedná se o field typu checkbox
        labelClass: React.PropTypes.oneOfType([
            React.PropTypes.string,
            React.PropTypes.object
        ]),
        inputClass: React.PropTypes.oneOfType([
            React.PropTypes.bool,
            React.PropTypes.object
        ]),
        // inlineErrorText,
    };

    static labelPosition = {
        left: 'left',
        right: 'right',
    };

    static defaultProps = {
        labelPosition: FieldGrid.labelPosition.left,
        labelClass: {xs: 12, sm: 4, md: 4, lg: 4, xl: 4, className: 'label-part'},
        inputClass: null,
        className: 'field-grid',
        required: false
    };

    static contextTypes = {
        form: React.PropTypes.bool,
        horizontal: React.PropTypes.bool,
        // inline: React.PropTypes.bool,
    };

    constructor(props) {
        super(props);
        this.uniqueId = newId();
    }

    render() {
        const {inlineErrorText, className, required, check, label, checkboxLabel, labelPosition, children, labelClass, inputClass, ...otherProps} = this.props;
        const {form, horizontal} = this.context;

        const componentProps = {
            ...otherProps,
            className: classNames(className, { required })
        };

        if (form && horizontal) {
            componentProps.row = true;
        }

        const componentClass = form ? FormGroup : Row;

        // Input / Children

        let child;

        let customInputClass = {...inputClass};

        // Pokud není label a je nastavena výchozí hodnota inputClass z defaultProps
        if (inputClass === null) {
            if (check || label === false) {
                customInputClass = {
                    ...DEFAULT_INPUT_CLASS,
                    ...DEFAULT_OFFSETS_INPUT_CLASS
                }
            } else {
                customInputClass = {
                    ...DEFAULT_INPUT_CLASS
                }
            }
        }

        if (label === false && (!check || (check && checkboxLabel == null))) {
            if (inlineErrorText) {
                child = <Col {...customInputClass}>
                    <UncontrolledTooltip tether={{classes: {enabled: "show form-error-field-tether"}}} className="error-text" target={this.uniqueId}>{inlineErrorText}</UncontrolledTooltip>
                    <div id={this.uniqueId}>
                        {children}
                    </div>
                </Col>
            } else {
                child = <Col {...customInputClass}>{children}</Col>;
            }
            return React.createElement(componentClass, componentProps, child);
        }

        /// Label
        let labelComponent;
        const useLabel = label || checkboxLabel;
        if (Array.isArray(useLabel) || typeof useLabel === 'string') {
            let labelProps = {
                message: useLabel,
                component: check ? "span" : Label,
            };

            if (horizontal) {
                labelProps = {
                    ...labelProps,
                    ...labelClass,
                };
            }

            labelComponent = <TranslateComponent {...labelProps} />
        } else {
            labelComponent = <Col {...labelClass}>
                {useLabel}
            </Col>;
        }


        const wrapComponent = horizontal ? Col : "div";
        if (!check) {
            // child = <Col {...customInputClass}>{children}</Col>;
            child = React.createElement(wrapComponent, customInputClass, children);
        } else {
            const childrenWithProps = React.Children.map(this.props.children, child => {
                return child ? React.cloneElement(child, { label: labelComponent }) : child;
            });
            // child = <Col {...customInputClass}>{childrenWithProps}</Col>;
            child = React.createElement(wrapComponent, customInputClass, childrenWithProps);

            // labelComponent = <Col {...labelClass}></Col>;
            labelComponent = React.createElement(wrapComponent, labelClass);
        }

        if (labelPosition === FieldGrid.labelPosition.left) {
            return React.createElement(componentClass, componentProps, labelComponent, child);
        } else if (labelPosition === FieldGrid.labelPosition.right) {
            return React.createElement(componentClass, componentProps, child, labelComponent);
        } else {
            throw new Error('Unknown label position.');
        }
    }
}

export default FieldGrid
